import { createSlice } from "@reduxjs/toolkit";
import Swal from "sweetalert2";
import { errorHandler } from "../../../helpers/errorHandler";
import {
    Call,
    CallWithFormData,
    mergeFormData,
    objectToFormData,
} from "../../../helpers/fetch";
import {
    startUILoading,
    stopUILoading,
} from "../../actions/administrador/ui/ui";

const initialState = {
    active: null,
    list: [],
    pagination: {
        data: [],
        per_page: 10,
        total: 0,
    },
};

export const EarlyInterventionFollowups = createSlice({
    name: "EarlyInterventionFollowups",
    initialState,
    reducers: {
        setActive: (state, action) => {
            state.active = action.payload;
        },
        unsetActive: (state) => {
            state.active = null;
        },
        setList: (state, action) => {
            state.list = action.payload;
        },
        clearList: (state) => {
            state.list = initialState.list;
        },
        setPagination: (state, action) => {
            state.pagination = action.payload;
        },
        clearPagination: (state) => {
            state.pagination = initialState.pagination;
        },
    },
});

export const {
    setActive,
    unsetActive,
    setList,
    clearList,
    setPagination,
    clearPagination,
} = EarlyInterventionFollowups.actions;

export default EarlyInterventionFollowups.reducer;

export const startShowEarlyInterventionFollowups = ({
    page = 1,
    query = "",
    number_rows = 25,
    asList = 0,
    early_intervention_id = null,
}) => {
    return async (dispatch) => {
        if (!asList) {
            dispatch(startUILoading());
        }

        const params = new URLSearchParams();

        params.set("page", page);
        params.set("q", query);
        params.set("per_page", number_rows);
        params.set("asList", asList);

        if (early_intervention_id) {
            params.set("early_intervention_id", early_intervention_id);
        }

        const resp = await Call(
            "operators/students/early-interventions/followups",
            "GET",
            params.toString()
        );

        if (resp.success) {
            if (asList) {
                dispatch(setList(resp.success));
            } else {
                dispatch(setPagination(resp.success));
            }
        } else {
            errorHandler(resp);
        }

        if (!asList) {
            dispatch(stopUILoading());
        }
    };
};

export const startCreateEarlyInterventionFollowup = (
    values,
    setErrors = () => {},
    callback = () => {},
    dispatchLoading = true
) => {
    return async (dispatch) => {
        if (dispatchLoading) {
            dispatch(startUILoading());
        }

        let data = objectToFormData(values);
        data.delete("files");

        const formData = new FormData();

        if (values?.files) {
            values.files.forEach((file, index) => {
                formData.append(`files[${index}]`, file);
            });
        }

        const resp = await CallWithFormData(
            "operators/students/early-interventions/followups",
            "POST",
            mergeFormData(data, formData)
        );

        if (resp.success) {
            Swal.fire({
                title: "Éxito",
                text: "Seguimiento registrado.",
                icon: "success",
                toast: true,
                position: "bottom-end",
                timer: 8000,
            });

            await callback(resp.success);
        } else {
            errorHandler(resp, setErrors);
        }

        if (dispatchLoading) {
            dispatch(stopUILoading());
        }
    };
};
